import React, { useState } from 'react'
import { ChevronRight } from 'lucide-react'
import { NavLink } from 'react-router-dom'
import { CollapsibleTrigger } from '@/Components/ui/collapsible'
import { SidebarGroupLabel } from '@/Components/ui/sidebar'

const ParentLabel = ({ item }) => {
    return item.items?.length > 0 ? (
        <SidebarGroupLabel
            asChild
            className="group/label text-sm text-sidebar-foreground hover:bg-sidebar-accent hover:text-sidebar-accent-foreground"
        >
            <CollapsibleTrigger
                className={`hover:bg-transparent active:bg-transparent flex font-bold justify-start w-full text-white hover:text-white`}
            >
                <span>{item?.icon}</span>

                <span className="flex justify-between w-full">
                    <span className="ml-[10px]">{item.title}</span>
                    <span>
                        {item.items?.length > 0 ? (
                            <ChevronRight size={14} className="ml-auto transition-transform group-data-[state=open]/collapsible:rotate-90" />
                        ) : null}
                    </span>
                </span>
            </CollapsibleTrigger>
        </SidebarGroupLabel>
    ) : (
        <NavLink
            to={item.url}
            className={({ isActive }) => {
                return isActive && item.items?.length == 0 ? 'bg-primary-red rounded-md' : ''
            }}
        >
            <SidebarGroupLabel
                asChild
                className="group/label text-sm text-sidebar-foreground hover:bg-sidebar-accent hover:text-sidebar-accent-foreground"
            >
                <CollapsibleTrigger className={`hover:bg-transparent flex justify-start w-full font-bold text-white hover:text-white `}>
                    <span>{item?.icon}</span>
                    <span className="ml-[10px]">
                        {item.title}
                        {item.items?.length > 0 ? (
                            <ChevronRight className="ml-auto transition-transform group-data-[state=open]/collapsible:rotate-90" />
                        ) : null}
                    </span>
                </CollapsibleTrigger>
            </SidebarGroupLabel>
        </NavLink>
    )
}

export default ParentLabel
